const EnvService = {
    getEnv: () => {
        return window.apwOauth ? window.apwOauth : process.env;
    },
};

export default EnvService;